module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./~/xhr-promise/index.js
// module id = 7
// module chunks = 0 1